import React, { useState, ReactNode } from 'react';

interface TooltipProps {
        content: ReactNode;
        children: ReactNode;
        placement?: 'top' | 'bottom' | 'left' | 'right';
}
const Tooltip = ({ content, children, placement = 'top' }: TooltipProps) => {
        const [showTooltip, setShowTooltip] = useState(false);

        const getPlacementClasses = () => {
                switch (placement) {
                        case 'bottom':
                                return 'top-full mt-2 left-1/2 transform -translate-x-1/2';
                        case 'left':
                                return 'right-full mr-2 top-1/2 transform -translate-y-1/2';
                        case 'right':
                                return 'left-full ml-2 top-1/2 transform -translate-y-1/2';
                        case 'top':
                        default:
                                // Default to top placement
                                return 'bottom-full mb-2 left-1/2 transform -translate-x-1/2';
                }
        };

        return (
                <div className="relative inline-block">
                        <div
                                onMouseEnter={() => setShowTooltip(true)}
                                onMouseLeave={() => setShowTooltip(false)}
                                className="cursor-pointer"
                        >
                                {children}
                        </div>
                        {showTooltip && (
                                <div
                                        className={`absolute z-50 bg-gray-800 text-white text-sm rounded-md py-1 px-2 pointer-events-none transition-opacity duration-300 opacity-100 shadow-lg ${getPlacementClasses()}`}
                                >
                                        {content}
                                        {/* Optional arrow indicator */}
                                        <div className="absolute h-2 w-2 bg-gray-800 transform rotate-45"
                                                style={{
                                                        // Arrow positioning logic (simplified for top placement default)
                                                        ... (placement === 'top' && { bottom: '-4px', left: '50%', transform: 'translateX(-50%) rotate(45deg)' }),
                                                        ... (placement === 'bottom' && { top: '-4px', left: '50%', transform: 'translateX(-50%) rotate(45deg)' }),
                                                        ... (placement === 'left' && { right: '-4px', top: '50%', transform: 'translateY(-50%) rotate(45deg)' }),
                                                        ... (placement === 'right' && { left: '-4px', top: '50%', transform: 'translateY(-50%) rotate(45deg)' }),
                                                }}
                                        />
                                </div>
                        )}
                </div>
        );
};

export default Tooltip;

